import config from 'app-config'


const resolveEndpoint = (endpoint) => {
  if (/^http|^\//.test(endpoint)) {
    return endpoint
  }

  // TODO remove this when there will be two builds on server
  if (config.env === 'development' || config.http.host === 'localhost') {
    return config.services.api + endpoint.replace(/^\//, '')
  }

  return `${window.location.origin}/${endpoint.replace(/^\//, '')}`
}


export default resolveEndpoint
